import { render, staticRenderFns } from "./le-company-underandparent-select.vue?vue&type=template&id=29b7979e&"
import script from "./le-company-underandparent-select.vue?vue&type=script&lang=js&"
export * from "./le-company-underandparent-select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports